<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="유통데이터 활용 경진대회 지원" src="/images/sub/sub-visual-circulation.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first page-section--last">
            <div class="mb-20px">
                <v-tabs hide-slider class="v-tabs--btn" data-aos="fade-right" data-aos-delay="100">
                    <v-tab v-for="(item, index) in statuses" :key="index" :class="index == 0 ? 'pl-0' : 'pl-4px'" class="pr-4px min-w-auto">
                        <v-btn large outlined color="secondary" class="min-w-md-120px" @click="(filter.status = item.value), search(true)">
                            <span class="font-size-md-18">{{ item.name }}</span>
                        </v-btn>
                    </v-tab>
                </v-tabs>
            </div>

            <v-divider class="grey darken-4 mb-20px mb-md-32px" style="border-width: 2px 0 0;" />
            <v-row data-aos="fade-up" data-aos-delay="200">
                <template v-for="(application, index) in applications">
                    <v-col cols="6" md="4" lg="3" :key="index">
                        <image-board tile flat @click="$router.push(`/circulation/support/` + application._id)">
                            <template #image>
                                <v-img v-if="application.thumb" cover width="100%" :aspect-ratio="282 / 370" :src="application.thumb.src" class="grey lighten-5">
                                    <v-overlay absolute opacity="0" class="pt-10px pl-10px justify-start align-start">
                                        <v-chip v-if="application.status == '모집중'" large color="white" class="w-md-100px"><span class="font-weight-medium secondary--text">모집중</span></v-chip>
                                        <v-chip v-if="application.status == '모집 종료'" large color="white" class="w-md-100px"><span class="font-weight-medium secondary--text">모집 종료</span></v-chip>
                                    </v-overlay>
                                </v-img>
                            </template>

                            <template #subject>
                                {{ application.subject }}
                            </template>

                            <template>
                                <v-row class="row--xs">
                                    <template v-for="(item, index) in application.items">
                                        <v-col cols="12" v-if="item.title == '모집 기간'" :key="index">
                                            <div v-html="item.txt.replace(/\n/g, '<br/>')" class="font-size-16 grey--text text--lighten-1"></div>
                                        </v-col>
                                    </template>
                                </v-row>
                            </template>
                        </image-board>

                        <!-- <v-card tile flat @click="$router.push(`/circulation/support/` + application._id)" class="v-card--none-active-bg">
                            <v-img v-if="application.thumb" cover width="100%" :aspect-ratio="282 / 370" :src="application.thumb.src">
                                <v-overlay absolute opacity="0" class="pt-10px pl-10px justify-start align-start">
                                    <v-chip v-if="application.status == '모집중'" large color="white" class="w-md-100px"><span class="font-weight-medium secondary--text">모집중</span></v-chip>
                                    <v-chip v-if="application.status == '모집 종료'" large color="white" class="w-md-100px"><span class="font-weight-medium secondary--text">모집 종료</span></v-chip>
                                </v-overlay>
                            </v-img>

                            <div class="pt-18px pt-md-24px">
                                <div class="mb-4px mb-md-8px">
                                    <div class="font-size-18 font-size-md-20 font-weight-extrabold line-height-135 grey--text text--darken-4 text-truncate">{{ application.subject }}</div>
                                </div>
                                <v-row class="row--xs">
                                    <template v-for="(item, index) in application.items">
                                        <v-col cols="12" v-if="item.title == '모집 기간'" :key="index">
                                            <div v-html="item.txt.replace(/\n/g, '<br/>')" class="font-size-16 grey--text text--lighten-1"></div>
                                        </v-col>
                                    </template>
                                </v-row>
                            </div>
                        </v-card> -->
                    </v-col>
                </template>
            </v-row>

            <div class="v-pagination-wrap">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";

const statuses = [
    { name: "전체", value: null },
    { name: "모집중", value: "모집중" },
    { name: "모집 종료", value: "모집 종료" },
];

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/components/dumb/page-section.vue";
import ImageBoard from "@/components/dumb/image-board.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        ImageBoard,
    },
    data() {
        return {
            statuses,

            filter: {
                status: this.$route.query.status || null,
            },

            page: +this.$route.query.page || 1,
            pageCount: 0, // 페이징 분할 크기
            limit: 8, // n개 만큼 게시글 가져오기
            summary: { totalCount: 0 },
            applications: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search(false);
        },

        async search(routable = false) {
            // 페이징 or 필터 변경시 라우터 기록 -> 뒤로가기시 이전 라우터로 복귀
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
            }

            let { summary, applications } = await api.v1.circulation.applications.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.applications = applications;
        },
    },
};
</script>
